import React from 'react';
import { X,Share2 } from 'lucide-react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  // Inline style for the Modal Overlay
  const modalOverlayStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.6)', // Darkened background
    backdropFilter: 'blur(8px)', // Adds blur effect to the background
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 50,
    animation: 'fadeIn 0.5s ease-out, dimBackground 0.5s ease-out', // Fade-in and dimming effects
  };

  // Inline style for the Modal Box
  const modalStyle = {
    backgroundColor: 'white',
    borderRadius: '1.5rem',
    width: '90%', // Modal takes up 90% width
    maxWidth: '1200px', // Max width to keep it from stretching too wide
    // maxHeight: '90vh', // Ensures the modal does not exceed 90% of the viewport height
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.2)', // Soft shadow around modal
    animation: 'slideIn 0.4s ease-out, zoomIn 0.4s ease-out', // Slide-in and zoom-in effects
    height: '98%'
  };

  // Inline style for the Modal Header (Close Button area)
  const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1rem',
   
    background: 'rgba(255, 255, 255, 0.95)', // Slight transparency for header
    borderRadius: '1.5rem 1.5rem 0 0',
  };
  const headingContainerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px", // Spacing between icon and text
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  };
  
  const headingStyle = {
    fontSize: "26px",
    fontWeight: "bold",
  
    letterSpacing: "1px",
    textTransform: "uppercase",
  };
  const iconStyle = {
    width: "24px",
    height: "24px",
   
  };
  
  const closeButtonStyle = {
    background: 'rgba(255, 255, 255, 0.3)', // Transparent background
    padding: '0.75rem',
    borderRadius: '50%', // Circular button shape
    border: 'none', // Remove the border
    transition: 'background-color 0.3s, transform 0.3s ease, box-shadow 0.3s ease', // Smooth hover effect
    margin: '-0.5rem', // Margin to slightly overlap the top-right corner of the modal
    cursor: 'pointer', // Add cursor pointer to indicate it's clickable
  };
  
  // Inline style for the Close Icon (X icon)
  const closeIconStyle = {
    width: '1.5rem',
    height: '1.5rem',
    color: '#6b7280',
    transition: 'transform 0.3s ease', // Smooth transition for scaling on click
  };

  // Inline style for the Modal Content Area
  const modalContentStyle = {
    flex: 1,
    overflowY: 'auto', // Allows the content to scroll when it overflows
    padding: '1.5rem',
    color: '#333', // Text color for content
    fontSize: '1.1rem',
    lineHeight: '1.6',
    transition: 'transform 0.3s ease-in-out',
    scrollBehavior: 'smooth', // Smooth scrolling
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalStyle}>
      <div style={modalHeaderStyle}>
    <div style={headingContainerStyle}>
      <Share2 style={iconStyle} /> {/* Nodes/Network Icon */}
      <h2 style={headingStyle}>Relation Mapping</h2>
    </div>
    <button onClick={onClose} style={closeButtonStyle}>
      <X style={closeIconStyle} />
    </button>
  </div>

        <div style={modalContentStyle}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
